import React from 'react'
import { EditedValues } from '.'
import { ServerSettingsFormBulkView } from './server-settings-form-bulk-view'
import {
  ServerSettingsFormBulkStateManager,
  ServerSettingsFormValueBulk
} from './server-settings-form-bulk-state-manager'
import { ServerSettingsFormBulkFocusManager } from './server-settings-form-bulk-focus-manager'

export interface Props {
  readonly onCancel: () => void
  readonly onConfirm: (value: ServerSettingsFormValueBulk) => void
  readonly userIsProtect: boolean
  readonly isFreemium: boolean
  readonly isOpen: boolean
}

export interface State {
  readonly formValue: ServerSettingsFormValueBulk
  readonly editedValues: EditedValues
  readonly showSyslogEdit: boolean
  readonly showSamplingEdit: boolean
  readonly showBotProtectionEdit: boolean
}

interface BulkFormProps {
  readonly isOpen: boolean
  readonly onConfirm: (value: ServerSettingsFormValueBulk) => void
  readonly onCancel: () => void
  readonly isFreemium: boolean
  readonly userIsProtect: boolean
}

export const ServerSettingsFormBulk: React.FC<BulkFormProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  isFreemium,
  userIsProtect
}) => (
  <ServerSettingsFormBulkStateManager
    isFreemium={isFreemium}
    userIsProtect={userIsProtect}
  >
    {({
      reset: resetState,
      state,
      editShowData,
      formSetter,
      ...stateMgrProps
    }) => (
      <ServerSettingsFormBulkFocusManager editShowData={editShowData}>
        {({ setRefBotProtection, setRefSampling, setRefSyslog }) => (
          <ServerSettingsFormBulkView
            {...stateMgrProps}
            {...state}
            formSetter={formSetter}
            isOpen={isOpen}
            onConfirm={() => {
              onConfirm(state.formValue)
              resetState()
            }}
            onCancel={() => {
              onCancel()
              resetState()
            }}
            syslogOnChange={formSetter('syslog')}
            setRefSyslogToggle={setRefSyslog}
            setRefBotProtectionToggle={setRefBotProtection}
            setRefSamplingToggleInput={setRefSampling}
          />
        )}
      </ServerSettingsFormBulkFocusManager>
    )}
  </ServerSettingsFormBulkStateManager>
)
